import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPopoverSurfaceStatusProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import Loading from "../../../loading";
import Text from "../../../text";

const PopoverSurfaceStatus: FC<IPopoverSurfaceStatusProps> = ({
    customLocalize,
    customTheme,
    children,
    style,
    ...props
}) => {
    const {
        controlHeights,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlHeights,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-live="polite"
        role="status"
    >
        <Loading
            customTheme={customTheme}
            size="small"
            color="mid"
        />
        <Text
            customTheme={customTheme}
            variant="bodyMediumSize"
            style={stylesheet.text}
            color="mid"
        >
            {children ?? localize("loading")}
        </Text>
    </View>;
};
export default PopoverSurfaceStatus;
